var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mf-dialog',{attrs:{"title":_vm.title},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('v-card-text',[_c('div',{staticClass:"error-container"},_vm._l((_vm.errors),function(error,index){return _c('div',{key:error.message,staticClass:"error-item"},[_c('span',[_vm._v("Erro #"+_vm._s(index + 1))]),_c('code',{staticClass:"code-block"},[_vm._v(_vm._s(error.message))])])}),0)]),_c('v-card-actions',[_c('mf-action-buttons',{attrs:{"primary-button":{
        text: 'Copiar',
        action: _vm.copyToClipboard,
        isVisible: true
      }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }